/**
 * 
 * key
 * 
 */


const key = 'ZXF1aXBtZW50VHJhc2g='

export default key 